// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel.discriminator = undefined;
EnterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel.additionalProperties = false;
EnterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel.attributeTypeMap = [
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "prescriberId",
        "baseName": "prescriberId",
        "type": "number"
    },
    {
        "name": "ndcId",
        "baseName": "ndcId",
        "type": "number"
    },
    {
        "name": "writtenOn",
        "baseName": "writtenOn",
        "type": "Date"
    },
    {
        "name": "daySupply",
        "baseName": "daySupply",
        "type": "number"
    },
    {
        "name": "refills",
        "baseName": "refills",
        "type": "number"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "number"
    },
    {
        "name": "directions",
        "baseName": "directions",
        "type": "string"
    },
    {
        "name": "dispenseTypeId",
        "baseName": "dispenseTypeId",
        "type": "number"
    },
];
//# sourceMappingURL=enterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel.js.map